// navigationConfig.js
// Shared navigation configuration for sidebar and header

export const navigationConfig={
  // Menu items that appear in both sidebar and header
  common: [
    {
      id: 'dashboard',
      routeName: 'dashboardBase',
      route: { name: 'dashboardBase' },
      icon: 'mdi mdi-view-dashboard-outline',
      label: 'menu.dashboard',
    },


    {
      id: 'account',
      routeName: 'account',
      route: { name: 'account' },
      icon: 'mdi mdi-account',
      label: 'auth.account'
    }
  ],

  // Admin-only menu items
  admin: [

    {
      id: 'product',
      routeNames: ['listNewProduct', 'listProduct'],
      icon: 'mdi mdi-shopping',
      label: 'sidebar.moduleManagement',
      labelParams: { module: 'attr.product' },
      permission: ['listNewProduct', 'listProduct', 'manageProductReport'],
      hasSubmenu: true,
      subItems: [

        {
          id: 'myOperations',
          routeName: 'myOperations',
          route: { name: 'myOperations' },
          icon: 'mdi mdi-shopping',
          label: 'sidebar.myTransactions',
        },
        {
          id: 'myproducts',
          routeName: 'myproducts',
          route: { name: 'myproducts' },
          icon: 'mdi mdi-cart',
          label: 'sidebar.productslist',
          roles: ['admin']
        },
        // {
        //   id: 'OffersBids',
        //   routeName: 'OffersBids',
        //   route: { name: 'OffersBids' },
        //   icon: 'mdi mdi-gavel',
        //   label: 'sidebar.myOffersBids',
        // },
        {
          id: 'BidsList',
          routeName: 'BidsList',
          route: { name: 'BidsList' },
          icon: 'mdi mdi-gavel',
          label: 'sidebar.myAuctions',
        },
        // {
        //   id: 'MyReceivedOffers',
        //   routeName: 'MyReceivedOffers',
        //   route: { name: 'MyReceivedOffers' },
        //   icon: 'mdi mdi-shopping',
        //   label: 'sidebar.myReceivedOffres'
        // },
        // {
        //   id: 'MyReceivedAuctions',
        //   routeName: 'MyReceivedAuctions',
        //   route: { name: 'MyReceivedAuctions' },
        //   icon: 'mdi mdi-gavel',
        //   label: 'sidebar.myReceivedAuctions'
        // },
        {
          id: 'listNewProduct',
          routeName: 'listNewProduct',
          route: { name: 'listNewProduct' },
          icon: 'mdi mdi-shopping',
          label: 'sentence.waitingForValidation',
          permission: 'listNewProduct'
        },
        {
          id: 'listProductInSales',
          routeName: 'listProduct',
          route: { name: 'listProduct', params: { state: 'inSales' } },
          icon: 'mdi mdi-shopping',
          label: 'sentence.inSales',
          permission: 'listProduct'
        },
        {
          id: 'listProductSold',
          routeName: 'listProduct',
          route: { name: 'listProduct', params: { state: 'sold' } },
          icon: 'mdi mdi-shopping',
          label: 'sentence.sold',
          permission: 'listProduct'
        },
        {
          id: 'manageProductReport',
          routeName: 'manageProductReport',
          route: { name: 'manageProductReport' },
          icon: 'mdi mdi-bug',
          label: 'sidebar.productReportsManagement',
          permission: 'manageProductReport'
        }
      ]
    },
    {
      id: 'Booster',
      routeNames: ['manageBoosterPlans', 'manageBoosterPlansList', 'managePaymentTypes', 'manageBoosterPurchaseList'],
      icon: 'mdi mdi-rocket-launch',
      label: 'sidebar.moduleManagement',
      labelParams: { module: 'action.boost' },
      permission: ['manageBoosterPlans', 'manageBoosterPlansList', 'managePaymentTypes', 'manageBoosterPurchaseList'],
      hasSubmenu: true,
      subItems: [
        {
          id: 'manageBoosterPurchaseList',
          routeName: 'manageBoosterPurchaseList',
          route: { name: 'manageBoosterPurchaseList' },
          icon: 'mdi mdi-rocket',
          label: 'sidebar.boosterPurchasesManagement',
          labelParams: { module: 'booster-plans' },
          permission: 'manageBoosterPurchaseList',
        },
        {
          id: 'manageBoosterPlans',
          routeName: 'manageBoosterPlans',
          route: { name: 'manageBoosterPlans' },
          icon: 'mdi mdi-rocket-launch',
          label: 'sidebar.boosterPlansManagement',
          labelParams: { module: 'booster-plans' },
          permission: 'manageBoosterPlans'
        },
        {
          id: 'manageBoosterPlansList',
          routeName: 'manageBoosterPlansList',
          route: { name: 'manageBoosterPlansList' },
          icon: 'mdi mdi-rocket-launch',
          label: 'sidebar.boosterPlansManagement',
          labelParams: { module: 'booster-plans' },
          permission: 'manageBoosterPlansHide'
        },

        {
          id: 'managePaymentTypes',
          routeName: 'managePaymentTypes',
          route: { name: 'managePaymentTypes' },
          icon: 'mdi mdi-credit-card-outline',
          label: 'sidebar.paymentTypesManagement',
          labelParams: { module: 'payment-types' },
          permission: 'managePaymentTypes'
        },
      ]
    },

    {
      id: 'userManagement',
      routeNames: ['manageAdmin', 'manageUsers'],
      icon: 'mdi mdi-account-group',
      label: 'sidebar.moduleManagement',
      labelParams: { module: 'main.users' },
      permission: ['manageUsers', 'manageAdmin'],
      hasSubmenu: true,
      subItems: [
        {
          id: 'managePermissions',
          routeName: 'ManagePermissions',
          route: { name: 'ManagePermissions' },
          icon: 'mdi mdi-account-key',
          label: 'menu.permissionsManagement',
          permission: 'ManagePermissions'
        },

        {
          id: 'adminWallet',
          routeName: 'AdminWallet',
          route: { name: 'AdminWallet' },
          icon: 'mdi mdi-wallet',
          label: 'menu.walletManagement',
          permission: 'AdminWallet'
        },
        {
          id: 'manageAdmin',
          routeName: 'manageAdmin',
          route: { name: 'manageAdmin' },
          label: 'main.admin',
          icon: 'mdi mdi-shield-account',
          permission: 'manageAdmin'
        },
        {
          id: 'manageUsers',
          routeName: 'manageUsers',
          route: { name: 'manageUsers' },
          label: 'main.users',
          icon: 'mdi mdi-account-multiple',
          permission: 'manageUsers'
        }
      ]
    },
    {
      id: 'settings',
      routeNames: [
        'manageCategories',
        'manageFaqs',
        'manageStores',
        'privacyPolicyEdit',
        'termsOfUseEdit',
        'termsOfUseEdit'
      ],
      icon: 'mdi mdi-hammer-wrench',
      label: 'main.settings',
      labelParams: { module: 'main.settings' },
      permission: [
        'manageCategories',
        'manageFaqs',
        'manageStores',
        'privacyPolicyEdit',
        'termsOfUseEdit',
        'termsOfUseEdit'
      ],
      hasSubmenu: true,
      subItems: [
        {
          id: 'manageCategories',
          routeName: 'manageCategories',
          route: { name: 'manageCategories' },
          icon: 'mdi mdi-chart-pie',
          label: 'sidebar.moduleManagement',
          labelParams: { module: 'main.categories' },
          permission: 'manageCategories'
        },
        {
          id: 'manageFaqs',
          routeName: 'manageFaqs',
          route: { name: 'manageFaqs' },
          icon: 'mdi mdi-chart-pie',
          label: 'sidebar.moduleManagement',
          labelParams: { module: 'FAQ' },
          permission: 'manageFaqs'
        },

        {
          id: 'manageStores',
          routeName: 'manageStores',
          route: { name: 'manageStores' },
          icon: 'mdi mdi-store',
          label: 'sidebar.moduleManagement',
          labelParams: { module: 'sidebar.store' },
          permission: 'manageStores'
        },
        {
          id: 'manageChatbot',
          routeName: 'manageChatbot',
          route: { name: 'manageChatbot' },
          icon: 'mdi mdi-robot',
          label: 'sidebar.ChatbotManagement',
          labelParams: { module: 'chatbot' },
          permission: 'manageChatbot'
        },
        {
          id: 'privacyPolicyEdit',
          routeName: 'privacyPolicyEdit',
          route: { name: 'privacyPolicyEdit' },
          icon: 'mdi mdi-file-document',
          label: 'sidebar.privacyPolicy',
          permission: 'privacyPolicyEdit'
        },
        {
          id: 'termsOfUseEdit',
          routeName: 'termsOfUseEdit',
          route: { name: 'termsOfUseEdit' },
          icon: 'mdi mdi-file-document-outline',
          label: 'sidebar.termsOfService',
          permission: 'termsOfUseEdit'
        },
        {
          id: 'cookiesPolicyEdit',
          routeName: 'cookiesPolicyEdit',
          route: { name: 'cookiesPolicyEdit' },
          icon: 'mdi mdi-cookie',
          label: 'sidebar.cookiesPolicy',
          permission: 'termsOfUseEdit'
        },
      ]
    },

  ],

  // Client-only menu items
  client: [

    {
      id: 'clientWallet',
      routeName: 'ClientWallet',
      route: { name: 'ClientWallet' },
      icon: 'mdi mdi-wallet',
      label: 'sidebar.wallet'
    },
    {
      id: 'products',
      routeNames: ['myPurchases', 'mySales', 'listUserProducts', 'ListNonSoldProduct', 'ListPurchasedProduct'],
      icon: 'mdi mdi-shopping',
      label: 'sidebar.products',
      hasSubmenu: true,
      subItems: [
        {
          id: 'myOperations',
          routeName: 'myOperations',
          route: { name: 'myOperations' },
          icon: 'mdi mdi-arrow-left-right-bold',
          label: 'sidebar.myTransactions',
        },
        {
          id: 'myproducts',
          routeName: 'myproducts',
          route: { name: 'myproducts' },
          icon: 'mdi mdi-star',
          label: 'sidebar.myproducts',
          roles: ['client']
        },
        // {
        //   id: 'OffersBids',
        //   routeName: 'OffersBids',
        //   route: { name: 'OffersBids' },
        //   icon: 'mdi mdi-gavel',
        //   label: 'sidebar.myOffersBids',
        // },
        {
          id: 'BidsList',
          routeName: 'BidsList',
          route: { name: 'BidsList' },
          icon: 'mdi mdi-gavel',
          label: 'sidebar.myAuctions',
        },
        {
          id: 'listUserProducts',
          routeName: 'listUserProducts',
          route: { name: 'listUserProducts' },
          icon: 'mdi mdi-shopping',
          label: 'sidebar.myProductsInSales'
        },
        {
          id: 'mySales',
          routeName: 'mySales',
          route: { name: 'mySales' },
          icon: 'mdi mdi-cart-arrow-up',
          label: 'sidebar.mySales'
        },
        {
          id: 'myPurchases',
          routeName: 'myPurchases',
          route: { name: 'myPurchases' },
          icon: 'mdi mdi-cart-arrow-down',
          label: 'sidebar.myPurchases'
        },
        // {
        //   id: 'MyReceivedOffers',
        //   routeName: 'MyReceivedOffers',
        //   route: { name: 'MyReceivedOffers' },
        //   icon: 'mdi mdi-shopping',
        //   label: 'sidebar.myReceivedOffres'
        // },
        // {
        //   id: 'MyReceivedAuctions',
        //   routeName: 'MyReceivedAuctions',
        //   route: { name: 'MyReceivedAuctions' },
        //   icon: 'mdi mdi-gavel',
        //   label: 'sidebar.myReceivedAuctions'
        // },
        {
          id: 'listNonSoldProduct',
          routeName: 'ListNonSoldProduct',
          route: { name: 'ListNonSoldProduct' },
          icon: 'mdi mdi-cart-off',
          label: 'sidebar.productNotSold'
        },
        // {
        //   id: 'addStore',
        //   routeName: 'addStore',
        //   route: { name: 'addStore' },
        //   icon: 'mdi mdi-store',
        //   label: 'sidebar.store'
        // }
      ]
    }
  ],
  userProfile: [
  ]
};

/**
 * Helper function to get menu items based on user role
 * @param {Object} user - User object with roles and permissions
 * @returns {Array} Filtered menu items
 */
export function getMenuItems(user) {
  const isAdmin=user?.roles?.includes('ROLE_ADMIN');
  const roleItems=isAdmin? navigationConfig.admin:navigationConfig.client;

  return [...navigationConfig.common, ...roleItems];
}

/**
 * Check if user has required permission
 * @param {Object} user - User object with permissions
 * @param {String|Array} permission - Permission(s) to check
 * @returns {Boolean}
 */
export function hasPermission(user, permission) {
  if (!permission) return true;

  const permissions=Array.isArray(permission)? permission:[permission];
  return permissions.some(p =>
    user?.permissions?.some(userPerm => userPerm.component===p)
  );
}

/**
 * Filter menu items based on user permissions
 * @param {Array} items - Menu items to filter
 * @param {Object} user - User object
 * @returns {Array} Filtered items
 */
export function filterByPermissions(items, user) {
  return items.filter(item => hasPermission(user, item.permission));
}

/**
 * Check if route is active
 * @param {Object} item - Menu item
 * @param {String} currentRouteName - Current route name
 * @returns {Boolean}
 */
export function isMenuItemActive(item, currentRouteName) {
  if (item.routeName) {
    return currentRouteName===item.routeName;
  }
  if (item.routeNames) {
    return item.routeNames.includes(currentRouteName);
  }
  return false;
}

/**
 * Get visible sub-items based on permissions
 * @param {Array} subItems - Sub-menu items
 * @param {Object} user - User object
 * @returns {Array} Filtered sub-items
 */
export function getVisibleSubItems(subItems, user) {
  if (!subItems) return [];
  return subItems.filter(sub => hasPermission(user, sub.permission));
}